import styled from 'styled-components'

const ComponentStyled = styled.div`
  .share-box {
    max-width: 600px;
    margin: 0 auto;
    position: relative;

    .share-content {
      background-color: ${({ theme }) => theme.colors.secondaries.opacity30};
      padding: 24px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .share-desc {
        font-family: 'Cabin';
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        color: ${({ theme }) => theme.colors.black};
        margin-bottom: 25px;
      }

      .share-items {
        display: flex;
        border: 2px solid ${({ theme }) => theme.colors.secondaries.opacity100};
        border-radius: 4px;
        justify-content: space-between;

        .share-container {
          display: flex;
          flex: 1;

          .share-item {
            border-right: 2px solid ${({ theme }) => theme.colors.secondaries.opacity100};
          }
        }

        .share-item {
          width: 100%;
          margin: 0;
          padding: 12px;
          display: flex;
          text-align: center;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          flex: 1;
          transition: 0.5s ease all;
          cursor: pointer;
          border: 0px;

          &:hover {
            background: ${({ theme }) => theme.colors.secondaries.opacity5};
          }

          .share-item-copy {
            margin-top: 10px;
            font-family: 'Cabin';
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: ${({ theme }) => theme.colors.black};
          }
        }
      }
    }
  }
`

export default ComponentStyled
